import {Button, Memory} from "../../components";
import {useState} from "react";
import styles from '../../components/Button/Button.module.scss';
import Shuffle from "../../services/Shuffle";
import cn from "classnames";

const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const FirstMemory = ({handler}) => {
    const [success, setStep] = useState(true);
    const buttonText = success ? "А ты неплох! дальше — больше" : "Открой все повторяющиеся карточки",
        buttonType = !success ? 'disabled' : 'active';

    return (
        <Memory handler={setStep} arr={Shuffle([...arr, ...arr])}>
            <Button className={cn("mobile-memory", !success ? styles.arrow : '', styles.mobile)} text={buttonText} handler={success ? handler : () => null} type={buttonType} />
        </Memory>
    )
}